// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/Hair donation/emailUsImg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'poppinsregular' !important;
    font-size: 14px !important;
    color: #333 !important;
}

.bannertitle {
    font-size: 34px;
    font-family: 'poppinsbold';
    color: #fff;
    position: absolute;
    width: 100%;
    top: 195px;
}

select {
    cursor: pointer;
}

.bannerBgColor {
    background-color: #000;
}

.imgOpacity {
    opacity: .4;
}

.imgOpacityInner {
    opacity: .5;
}

/* ..........................................Fontsize-14 Start......................................... */
.BoldColor30 {
    font-size: 30px;
    font-family: 'poppinsbold';
    color: #A05B8A;
}

.BoldColor28 {
    font-size: 28px;
    font-family: 'poppinsbold';
    color: #A05B8A;
}

.BoldColor18 {
    font-size: 18px;
    font-family: 'poppinsbold';
    color: #A05B8A;
}

.BoldColor14 {
    font-size: 14px;
    font-family: 'poppinsbold';
    color: #A05B8A;
}

.RegularColor14 {
    font-size: 14px;
    font-family: 'poppinsregular';
    color: #A05B8A;
}


.Bold14 {
    font-size: 14px;
    font-family: 'poppinsbold';
}

.semibold14 {
    font-size: 14px;
    font-family: 'poppinssemibold';
}

.medium14 {
    font-size: 14px;
    font-family: 'poppinsmedium';
}

.Regular14 {
    font-size: 14px;
    font-family: 'poppinsregular';
}


/* ..........................................Fontsize-14 End......................................... */

/* ..........................................Fontsize-16 Start......................................... */

.Bold16 {
    font-size: 16px;
    font-family: 'poppinsbold';
}

.semibold16 {
    font-size: 16px;
    font-family: 'poppinssemibold';
}

.medium16 {
    font-size: 16px;
    font-family: 'poppinsmedium';
}

.Regular16 {
    font-size: 16px;
    font-family: 'poppinsregular';
}

/* ..........................................Fontsize-16 End......................................... */

/* ..........................................Fontsize-18 Start......................................... */

.Bold18 {
    font-size: 18px;
    font-family: 'poppinsbold';
}

.semibold18 {
    font-size: 18px;
    font-family: 'poppinssemibold';
}

.medium18 {
    font-size: 18px;
    font-family: 'poppinsmedium';
}

.Regular18 {
    font-size: 18px;
    font-family: 'poppinsregular';
}

/* ..........................................Fontsize-18 End......................................... */
/* ..........................................Fontsize-30 Start......................................... */

.Bold28 {
    font-size: 28px;
    font-family: 'poppinsbold';
}

/* ..........................................Fontsize-30 End......................................... */

/* ..........................................Space CSS Start......................................... */

.mr0 {
    margin-right: 0;
}

.mr5 {
    margin-right: 5px;
}

.mr10 {
    margin-right: 10px;
}

.mr15 {
    margin-right: 15px;
}

.mr20 {
    margin-right: 20px !important;
}

.mr60 {
    margin-right: 60px;
}


.ml0 {
    margin-left: 0;
}

.ml5 {
    margin-left: 5px;
}

.ml10 {
    margin-left: 10px;
}

.ml15 {
    margin-left: 15px;
}

.ml20 {
    margin-left: 20px;
}

.ml23 {
    margin-left: 23px;
}

.mt0 {
    margin-top: 0;
}

.mt10 {
    margin-top: 10px;
}

.mt15 {
    margin-top: 15px;
}

.mt20 {
    margin-top: 20px;
}

.mt30 {
    margin-top: 30px;
}

.mt36 {
    margin-top: 36px;
}

.mb0 {
    margin-bottom: 0;
}

.mb10 {
    margin-bottom: 10px;
}

.mb15 {
    margin-bottom: 15px;
}

.mb20 {
    margin-bottom: 20px;
}

.mb30 {
    margin-bottom: 30px;
}

.mb40 {
    margin-bottom: 40px;
}



.p0 {
    padding: 0 !important;
}

.p10 {
    padding: 10px;
}

.p15 {
    padding: 15px;
}

.p20 {
    padding: 20px;
}

.p30 {
    padding: 30px;
}

.p40 {
    padding: 40px;
}

.pt0 {
    padding-top: 0;
}

.pb0 {
    padding-bottom: 0 !important;
}



.p150 {
    padding: 15px 0;
}

.br {
    border-right: 0 !important;
}

/* ..........................................Space CSS End......................................... */


/* ..........................................ul li CSS Start......................................... */
.urlLinkRgular {
    color: #D42A9E;
}

.urlLinkRgular:hover {
    color: #ff00ae;
    text-decoration: none;
}


.noFlexlistContent {
    padding-left: 0;
    list-style-type: none;
}

.noFlexlistContent li {
    margin-bottom: 10px;
    margin-left: 20px;
}

.noFlexlistContent li::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;

}













.listContent {
    padding-left: 0;
    list-style-type: none;
}

.listContent li {
    margin-bottom: 10px;
    font-family: 'poppinsmedium';
    /* display: flex; */
}

.listContent li::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;
    /* background-image: url("../img/right-arrow.png"); */

}

.listContent .iIcon {
    color: #A05B8A;
    font-size: 14px;
}

.listContentRegular {
    padding-left: 0;
    list-style-type: none;
}

.listContentRegular li {
    margin-bottom: 10px;
    font-family: 'poppinsregular';
    /* display: flex; */

}


.listContentRegular li::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;

}

.listContentRegular .iIcon {
    color: #A05B8A;
    font-size: 14px;
}

.commoniIcon {
    color: #A05B8A;
    font-size: 14px;
}

.listContentUrl {
    padding-left: 0;
    list-style-type: none;
}

.listContentUrl li {
    margin-bottom: 10px;
    color: #A05B8A;
}

.listContentUrl li a {
    color: #A05B8A;
}

.listContentUrl li a::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;

}

.listContentUrl li a:hover {
    color: #A05B8A;
    text-decoration: none;
    color: #D42A9E;
}

.listContentUrl .iIcon {
    font-size: 14px;
}

.alistContentUrl a {
    margin-bottom: 10px;
    color: #A05B8A;
    font-size: 14px;
    font-family: 'poppinsmedium';
}

.alistContentUrl div {
    margin-bottom: 10px;
    color: #333;
}

.listContentP {
    padding-left: 0;
    list-style-type: none;
}




.listContentP li p {
    margin-bottom: 10px;
    font-family: 'poppinsmedium';
    /* display: flex; */
}

.listContentP li p::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;

}


.listContentPregular {
    padding-left: 0;
    list-style-type: none;
}




.listContentPregular li p {
    margin-bottom: 10px;
    font-family: 'poppinsregular';
    /* display: flex; */
}

.listContentPregular li p::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;

}
















.ulList {
    column-count: 3;
}

.ulList2 {
    column-count: 2;
}

.list-style {
    list-style-type: disc;
    padding-left: 20px !important;
}

.list-style strong {
    display: block;
}

/* ..........................................ul li CSS End......................................... */


.tataContentBox {
    background-color: #ffffff;
    border: 1px solid #F3DDDE;
    border-radius: 4px;
    padding: 20px;
}

.tataContentBoxGray {
    background-color: #EEF4F6;
    border-radius: 4px;
    padding: 20px;
}

.displayNone {
    display: none;
}

.header-wrapper {
    padding: 32px 24px 0 24px;
    display: flex;
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: #eee;
}

.shadow {
    /* -webkit-box-shadow: 0 14px 12px -6px rgb(230, 230, 230);
    -moz-box-shadow: 0 14px 12px -6px rgb(230, 230, 230);
    box-shadow: 0 14px 12px -6px rgb(230, 230, 230); */
    border-bottom: 1px solid #ddd !important;
}

.wrapper {
    height: 200vh;
}



.cardImg {
    width: 100%;
}

.displayNone {
    display: none;
}


.socialMediaSection {
    background-color: #3D1D33;
    padding: 5px 0;
    width: 100%;
    display: block;
}

.socialHeader {
    display: flex;
    align-items: center;
}

.socialIcon {
    width: 100%;
    display: flex;
    align-items: center;

}

.search {
    display: flex;
    width: 70%;

}

.search a {
    margin-right: 20px;
    color: #9E8E99;
    text-decoration: none;

}

.socialIcon a {
    padding: 0 10px;
    color: #9E8E99;
}

.socialTitle {
    color: #9E8E99;
    margin-right: 5px;
}


.flex {
    display: flex;
    align-items: center;
}

.flexJustify {
    display: flex;
    justify-content: center;
    align-items: center;
}


.flexJustify1 {
    display: flex;
    justify-content: center;

}


input {
    font-size: 14px !important;
}

.bg-light {
    padding: 0;
    display: block;
    background-color: #fff !important;
}





.nav-link {
    display: block;
    padding: 1.3rem 1rem;
}

.search .form-control {
    line-height: 1.5;
}

.main {
    width: 50%;
    margin: 50px auto;
}


.has-search .form-control {
    padding-left: 2.375rem;
}

.has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}

.search .form-group {
    margin-bottom: 0;
}

.navbar-nav .nav-link {
    color: #000 !important;
    font-family: 'poppinsbold';
    /* border-bottom: 3px solid #0078d300; */
    /* padding-right: 1.5rem !important; */
    text-decoration: none;
}

.navbar-nav li a {
    color: #000 !important;
    font-family: 'poppinsbold';
    text-decoration: none;
    height: 63px;
}


.navbar-nav li a:hover {
    color: #D42A9E !important;
    font-family: 'poppinsbold';
    /* border-bottom: 3px solid #D42A9E; */
    text-decoration: none;
    height: 63px;
}



.dropdown-menu {
    margin: 0rem 0 0;
    box-shadow: 0px 2px 9px 0px rgba(89, 89, 89, 0.48);
    -webkit-box-shadow: 0px 2px 9px 0px rgba(89, 89, 89, 0.48);
    -moz-box-shadow: 0px 2px 9px 0px rgba(89, 89, 89, 0.48);
    border: 0;
    font-size: 14px;
}


.dropdown-menu a {
    color: #333 !important;
    text-transform: none;
    padding: 21px 15px;
    font-family: 'poppinsregular';
}

.boxes {
    transition: all 1s;
}

.dropdown-menu li {
    color: #A05B8A !important;
    font-family: 'poppinsregular' !important;
    padding: 0 !important;

}

.dropdown-menu li a {
    color: #A05B8A !important;
    font-family: 'poppinsregular' !important;
    padding: 8px 14px !important;
    height: auto !important;
}


.dropdown-menu li a:hover {
    color: #D42A9E !important;
    text-transform: none !important;
    transition: all 0.5s !important;
    transform: translateX(5px) !important;
    background-color: transparent !important;
    border-bottom: 0;
    font-family: 'poppinsregular';
}

.dropdownItem {
    display: block;
}

.dropdown .dropdown-toggle::after {
    vertical-align: 0.1em;
}

.navbar-brand {
    margin-right: 6rem;
}


.topspace {
    margin-top: 108px;
}

.topHeight {
    height: 30px;
}

.bannerContent {
    position: absolute;
    z-index: 999;
    text-align: center;
    top: 150px;
    width: 49%;
    left: 360px;

}

.bannerContent h2 {
    font-family: 'poppinsbold';
    color: #fff;
    line-height: 56px;
    font-size: 39px;
}

.bannerContent p {
    color: #fff;
    width: 477px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}



.bannerContent2 {
    position: absolute;
    z-index: 999;
    text-align: center;
    top: 180px;
    width: 49%;
    left: 360px;

}

.bannerContent2 h2 {
    font-family: 'poppinsbold';
    color: #fff;
    line-height: 56px;
    font-size: 39px;
}

.bannerContent2 p {
    color: #fff;
    width: 477px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}


.colorTitle {
    color: #D42A9E;
}

.carousel-indicators li {
    position: relative;
    flex: 0 1 auto;
    width: 10px;
    height: 10px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    background-color: rgba(255, 255, 255, .5);
    border-radius: 100%;
    cursor: pointer;
}

.carousel-indicators .active {
    background-color: #D42A9E;
}

.btn-primary {
    background-color: #D42A9E;
    text-transform: uppercase;
    font-size: 14px;
    border: 2px solid #f7c5e7;
}

.btn-primary:hover {
    background-color: #D42A9E;
    border: 2px solid #f7c5e7;
}

.btn-primary:focus {
    box-shadow: none;
    background-color: #D42A9E;
}

.btn:hover {
    transform: translateY(-2px);
}

.btn {
    transition: transform 250ms;
    font-size: 14px;

}

.Allbtn {
    font-family: 'poppinsregular';
    color: #fff !important;
}

.btn-primary:not(:disabled):not(.disabled):active {
    border: none;
    background-color: #D42A9E;
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    background-color: #D42A9E;
}

.banner-btn {
    border-radius: 100%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #D42A9E;
}

.title {
    font-family: 'poppinsbold';
    font-size: 28px;
    margin-bottom: 0px
}

.titleWhite {
    font-family: 'poppinsbold';
    font-size: 28px;
    margin-bottom: 0px;
    color: #fff;

}

.whiteContent {
    color: #fff;
}



.tagLine {
    color: #666;
}

.tagLineWhite {
    color: #fff;
}

.contentSection {
    padding: 50px 0;
}


.divider {
    border: 2px solid #D42A9E;
    margin: 10px 0;
    width: 90px;
    margin-left: auto;
    margin-right: auto;
}

.dividerWhite {
    border: 2px solid #ffffff;
    margin: 10px 0;
    width: 90px;
    margin-left: auto;
    margin-right: auto;
}

.footerBg {
    background-color: #3D1D33;
    padding: 30px 0;
}


.boxes1 {
    transition: all 1s;
}

.footerLink {
    padding: 0;
    width: 300px;
    list-style-type: none;
}


.footerLink li a {
    padding: 0;
    color: #9E8E99 !important;
    font-size: 14px !important;
    margin-bottom: 15px;


}

.footerLink li a:hover {
    color: #D42A9E !important;
    text-transform: none;
    transition: all 0.5s;
    transform: translateX(5px);
    background-color: transparent !important;
    border-bottom: 0;
    font-family: 'poppinsregular';

}

.footerMenuTitle {
    font-family: 'poppinsbold';
    font-size: 18px;
    color: #A05B8A;
    margin-bottom: 10px;

}

.socialIcon .btn {
    padding: 0;
    font-size: 14px !important;
}

.socialIcon .btn:hover {
    color: #D42A9E !important;
}

.search .btn {
    padding: 0;
    font-size: 14px !important;
}

.search .btn:hover {
    color: #D42A9E !important;
}

.copyRight {
    color: #A799A3;
    padding: 15px 0;
    text-align: center;
    background-color: #503447;
}

.contentBox {

    padding: 40px 0;
}



.listContentRegular {
    padding-left: 0;
    list-style-type: none;
}

/* 
#listyling ul {
    list-style-type: none;
    content: '\\f061';
    list-style-position: inside;
    padding-left: 1.5em;
    padding-left: 0;


}

#listyling ul li a {
    margin-bottom: 15px;
    color: #A05B8A;
    text-decoration: none;
}

#listyling ul li a:hover {
    margin-bottom: 15px;
    color: #A05B8A;
    text-decoration: none;
    color: #D42A9E;
}

#listyling ul li::before {
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    content: '\\f061';
    margin-right: 10px;
    color: #A05B8A;

} */

.threeLineText {
    overflow: hidden;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

}

.threeLineTitle {
    overflow: hidden;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    color: #000;
}

.threeLineTitle:hover {
    color: #D42A9E;
    text-decoration: none;
}

.threeLineTitleNew {
    overflow: hidden;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    color: #000;
}

.threeLineTitleNew:hover {
    color: #000;
    text-decoration: none;
    cursor: auto;
}

/* .aLink {
    color: #D42A9E;
    text-decoration: none;

}

.aLink:hover {
    color: #D42A9E;
    text-decoration: none;

} */

.darkPinkBg {
    background-color: #3D1D33;
}

.grayBg {
    background-color: #EEF4F6;
}

.roundedBox {
    border-radius: 10px;
    background-color: #fff;

}

.titleBg {
    border-radius: 10px 10px 0 0;
    padding: 15px;
    background-color: #A05B8A;
    font-size: 18px;
    color: #fff;
    font-family: 'poppinssemibold';
    display: flex;
    align-items: center;
}

.roundedBoxContent {
    padding: 15px;
}

.iIconRight {
    color: #A05B8A;
    font-size: 14px;
    margin-top: 3px;
    position: absolute;
    left: 35px;
}



.dateFormat {
    text-transform: uppercase;
    font-size: 14px;
    color: #666666;
    margin-bottom: 5px;

}

.dateFormatGray {
    text-transform: uppercase;
    font-size: 14px;
    color: #999;
    margin-bottom: 5px;

}

.addFormatGray {
    text-transform: uppercase;
    font-size: 14px;
    color: #999;
    margin-bottom: 5px;

}

.feedbackCards {
    column-count: 3;
    column-count: 3;
    list-style-type: none;
    padding: 0;

}

.liBlock {
    display: inline-block;
}

.tableNumber1 {
    text-align: center;
    background: #A05B8A;
    padding: 20px 0 0;
    width: 25%;
    color: #fff;
    font-size: 34px;
    font-family: 'poppinsmedium';
    border-radius: 4px 0 0 0;
}

.tableNumber2 {
    text-align: center;
    background: #965BA0;
    padding: 20px 0 0;
    width: 25%;
    color: #fff;
    font-size: 34px;
    font-family: 'poppinsmedium';

}

.tableNumber3 {
    text-align: center;
    background: #5BA09C;
    padding: 20px 0 0;
    width: 25%;
    color: #fff;
    font-size: 34px;
    font-family: 'poppinsmedium';
}

.tableNumber4 {
    text-align: center;
    background: #5CA05B;
    padding: 20px 0 0;
    width: 25%;
    color: #fff;
    font-size: 34px;
    font-family: 'poppinsmedium';
    border-radius: 0 4px 0 0;

}

.tableHeading1 {
    text-align: center;
    background: #A05B8A;
    padding: 0 20px 20px;
    width: 25%;
    color: #fff;
    border-radius: 0 0 0 4px;
}

.tableHeading2 {
    text-align: center;
    background: #965BA0;
    padding: 0 20px 20px;
    width: 25%;
    color: #fff;
}

.tableHeading3 {
    text-align: center;
    background: #5BA09C;
    padding: 0 20px 20px;
    width: 25%;
    color: #fff;
}

.tableHeading4 {
    text-align: center;
    background: #5CA05B;
    padding: 0 20px 20px;
    width: 25%;
    color: #fff;
    border-radius: 0 0 4px 0;

}

.pm {
    margin-left: 25px;
}

.imgBox {
    border-radius: 4px;
    border: 1px solid #999999;
}

.linkBox {
    background-color: #EEF4F6;
    padding: 20px;
}


.twitterIcon {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/twitterIcon.png");
    width: 13px;
    height: 12px;
    background-repeat: no-repeat;
}

.twitterIcon:hover {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/twitterIconColor.png");
    width: 13px;
    height: 12px;
    transform: translateY(-2px);
}

.cBtn {
    transition: transform 250ms;
}



/* ............................................tabs start.................................................. */
.required:after {
    content: " *";
    color: red;
}



.form-control {
    font-size: 14px;
}



.form-group ::placeholder {
    color: #999;
}

.contactInfoBox {
    background-color: #EEF4F6;
    padding: 20px;
    border-radius: 4px;
}



.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    border-top: #FFFFFF;
    border-right: #FFFFFF;
    border-left: #FFFFFF;
    border-bottom: 3px solid #D42A9E;
    color: #D42A9E !important;
}

.nav-tabs {
    border-bottom: 1px solid #fff;
}


.nav-tabs .nav-link {
    border: 0px solid transparent;
    padding: 10px 0;
    margin-right: 30px;
}

#myTab li a {
    font-family: 'poppinsmedium';
    color: #999999;

}

/* ............................................tabs end.................................................. */

.locationSelector {
    /* background-color: #f3f3f3; */
    background-color: #52273e;
    padding: 20px 50px;
    border-radius: 4px;

}

.locationSelector label {
    color: #fff;

}



.addressBox {
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    background-color: #FEFEFE;
    height: 100%;
}

.innerAddressBox {
    padding: 20px;
}

.addressTitle {
    background-color: #b55b8a;
    padding: 15px;
    color: #fff;
}


.textwithImg {
    width: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    float: left;
    margin-right: 30px;
}

.textwithImg1 {
    width: auto;

    margin-bottom: 20px;
    float: right;
    margin-left: 30px;
}

.videoYoutube {
    height: 304px;
    width: 100%;
}

.homeVideoYoutube {
    height: 416px;
    width: 50%;
}

.form-inline a {
    padding: 0.375rem 0.75rem !important;
}















.mainmenu a,
.navbar-default .navbar-nav>li>a,
.mainmenu ul li a,
.navbar-expand-lg .navbar-nav .nav-link {
    color: #000;
    font-size: 14px;
    padding: 21px 15px;
    display: block !important;

}

.mainmenu .active a,
.mainmenu .active a:focus,
.mainmenu .active a:hover,
.mainmenu li a:hover,
.mainmenu li a:focus,
.navbar-default .navbar-nav>.show>a,
.navbar-default .navbar-nav>.show>a:focus,
.navbar-default .navbar-nav>.show>a:hover {
    color: #D42A9E;
    background: #ffffff;
    outline: 0;
    padding: 21px 15px;
    /* border-bottom: 3px solid #D42A9E; */

}

/*==========Sub Menu=v==========*/
.mainmenu .collapse ul>li:hover>a {
    background: #fff;
    padding: 21px 15px;
}

.mainmenu .collapse ul ul>li:hover>a,
.navbar-default .navbar-nav .show .dropdown-menu>li>a:focus,
.navbar-default .navbar-nav .show .dropdown-menu>li>a:hover {
    background: #fff;
    border-bottom: 0;
    /* padding: 21px 15px; */
    padding: 15px 15px;
}

.mainmenu .collapse ul ul ul>li:hover>a {
    background: #fff;
    /* padding: 21px 15px; */
    padding: 15px 15px;
}

.mainmenu .collapse ul ul,
.mainmenu .collapse ul ul.dropdown-menu {
    background: #fff;
    /* padding: 21px 15px; */
    padding: 15px 15px;
}

.mainmenu .collapse ul ul ul,
.mainmenu .collapse ul ul ul.dropdown-menu {
    background: #fff;
}

.mainmenu .collapse ul ul ul ul,
.mainmenu .collapse ul ul ul ul.dropdown-menu {
    background: #fff;
}

/******************************Drop-down menu work on hover**********************************/
.mainmenu {
    border: 0 solid;
    margin: 0;
    padding: 14px 0;
    min-height: 100%;
    width: 100%;
    background: #fff;
    font-family: 'poppinsbold';
    padding: 21px 15px;

}

@media only screen and (min-width: 767px) {
    .mainmenu .collapse ul li:hover>ul {
        display: block
    }

    .mainmenu .collapse ul ul {
        position: absolute;
        top: 100%;
        left: 0;
        min-width: 265px;
        display: none
    }

    /*******/
    .mainmenu .collapse ul ul li {
        position: relative
    }

    .mainmenu .collapse ul ul li:hover>ul {
        display: block
    }

    .mainmenu .collapse ul ul ul {
        position: absolute;
        top: 0;
        left: 100%;
        min-width: 250px;
        display: none
    }

    /*******/


}

@media only screen and (max-width: 767px) {
    .navbar-nav .show .dropdown-menu .dropdown-menu>li>a {
        padding: 16px 15px 16px 35px
    }

    .navbar-nav .show .dropdown-menu .dropdown-menu .dropdown-menu>li>a {
        padding: 16px 15px 16px 45px
    }
}










/* ............................................tabs start.................................................. */
.stepsBg .required:after {
    content: " *";
    color: red;
}

.stepsBg .form-control {
    font-size: 14px;
}



.stepsBg .form-group ::placeholder {
    color: #999;
}

.stepsBg .contactInfoBox {
    background-color: #EEF4F6;
    padding: 20px;
    border-radius: 4px;
}

.stepsbgImg {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/steps-bg.jpg");
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;


}

.stepContentBox {
    border-radius: 0 0 4px 4px;
    padding: 20px;
    background-color: #fff;
    height: 458px;
    overflow-y: scroll;
}



.stepsBg .nav-tabs .nav-item.show .nav-link,
.stepsBg .nav-tabs .nav-link {
    border-top: #FFFFFF;
    border-right: #FFFFFF;
    border-left: #FFFFFF;
    padding: 10px 10px 20px 10px !important;
    /* border-radius: 10px; */
    color: #fff !important;
    /* background-color: #999; */
    /* border: 2px solid #999 !important; */
    clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 69% 75%, 50% 99%, 30% 75%, 0% 75%);

}

.stepsBg .nav-tabs .nav-item.show .nav-link,
.stepsBg .nav-tabs .nav-link:hover {
    border-top: #FFFFFF;
    border-right: #FFFFFF;
    border-left: #FFFFFF;
    padding: 10px 10px 20px 10px !important;
    /* border-radius: 10px; */
    color: #fff !important;
    background-color: #999;



}

.stepsBg .nav-tabs .nav-item.show .nav-link,
.stepsBg .nav-tabs .nav-link.active {
    border-top: #FFFFFF;
    border-right: #FFFFFF;
    border-left: #FFFFFF;
    padding: 10px 10px 20px 10px !important;
    /* border-radius: 10px; */
    color: #fff !important;
    background-color: #d42a9e;
    border-bottom: 0;

    clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 69% 75%, 50% 99%, 30% 75%, 0% 75%);

}

.stepsBg .nav-tabs {
    border-bottom: 1px solid transparent !important;
    padding: 0 0 10px 0 !important;

}


/* .stepsBg .nav-tabs .nav-link {
    border: 0px solid transparent;
    padding: 10px 0;
    margin-right: 50px;
} */

.stepGrayBg {
    /* background-color: #f3f3f3; */
    /* padding: 20px 10px 0 10px; */
    border-radius: 4px 4px 0 0;

    border-bottom: 2px solid #d42a9e !important;
    /* -webkit-box-shadow: inset 0px -18px 31px -12px rgba(179, 179, 179, 1);
    -moz-box-shadow: inset 0px -18px 31px -12px rgba(179, 179, 179, 1);
    box-shadow: inset 0px -18px 31px -12px rgba(179, 179, 179, 1); */
}


.stepsBg #myTab li a {
    font-family: 'poppinsbold';
    color: #B5B5B5;
    font-size: 18px;


}

#accordion a {
    font-family: 'poppinsbold';
    color: #d42a9e;
    font-size: 18px;
    cursor: pointer;

}

.cardHeader {

    cursor: pointer;

}

/* Spinner.css (CSS Styles) */

.tableWidth {
    width: 60%;
}

/* ............................................tabs end.................................................. */

.socialIcons {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
}

.socialIcons li {
    float: left;
    padding: 20px;
    border: 1px solid #ccc;
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

}

.socialIcons li a {
    display: block;
    color: #999;
    text-align: center;
    text-decoration: none;
    font-size: 15px;
}

.socialIcons li a:hover {
    color: #D42A9E;
}

.titleWidth {
    width: 67%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

.imgFixbox {
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    height: 100%;
    display: inline-table;
}

.imgFixbox1 {
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    height: 100%;
    display: inline-table;
    width: 100%;
}

.imgFixbox2 {
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    height: 100%;
    display: inline-table;
    width: 100%;
    margin: 10px;
}

.imgFixbox3 {
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    height: 129px;
    display: inline-table;
    width: 100%;
    margin-bottom: 15px;
}

.imgFixboxBorder {

    border: 1px solid #7c7c7c;
    padding: 10px;
    height: 129px;
    display: inline-table;
    width: 100%;
    margin-bottom: 15px;
}

.spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
    margin: auto;
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #3498db;
    /* Change the color to your liking */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* ............................................tabs end.................................................. */

.peginationBox a {
    padding: 8px 10px;
    cursor: pointer;
    border: 2px solid #ccc;
    margin: 5px;
    font-family: 'poppinsbold';
    color: #d42a9e;

}

.peginationBox a:hover {
    padding: 8px 10px;
    cursor: pointer;
    border: 2px solid #d42a9e;
    margin: 5px;
    color: #d42a9e;
    font-family: 'poppinsbold';


}

.peginationActive {
    border: 2px solid #d42a9e !important;
    color: #d42a9e !important;
}

.imgAdjt {
    float: right;
    margin-right: 363px;
    margin-left: 20px;
}

.imgAdjt0 {
    float: right;
    margin-right: 0px;
    margin-left: 20px;
}

.emailUsImg {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;


}

.searchWidth .main {
    width: 50%;
    margin: 50px auto;
}

/* Bootstrap 4 text input with search icon */

.searchWidth .has-search .form-control {
    padding-left: 2.375rem;
}

.searchWidth .has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}

.form-card{
    border: #ddd 1px solid;
    padding: 1rem;
}

.buttonColor {
    background-color: #D42A9E;
    border-color: #D42A9E;
}

.buttonColor:hover {
    background-color: #9c076d;
    border-color: #D42A9E;
}

.buttonColor:focus {
    background-color: #9c076d;
    border-color: #D42A9E;
}

.buttonColor:active {
    background-color: #9c076d !important;
    border-color: #D42A9E;
}

.input-group-append .btn:hover {
    transform: none;
}

.searchWidth {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
}

.olListTypenone {
    list-style-type: none;
    padding: 0;

}

.whatsAppIcon {
    color: #3FBE4F;
}

.footerLink .dropdown-item:focus {
    background-color: transparent;
}

.wordBreak {
    word-wrap: break-word;
}

.modalDialog {
    max-width: 750px;
}

.modalHeader {
    border-bottom: 0;
}

.image-gallery-left-nav .image-gallery-svg,
.image-gallery-right-nav .image-gallery-svg {
    height: 101px !important;
    width: 42px !important;
}

.pointer {
    cursor: pointer;
}

.modalHeight {
    max-height: 493px;
    overflow: auto;
}

/* .AllbtnImg {
    font-family: 'poppinsregular';
    color: #fff !important;
}

.AllbtnImg:hover {
    font-family: 'poppinsregular';
    color: #fff !important;
    background-image: url("../img/3-1.png");
} */

.facebookLink {
    color: #3498db;
    font-size: 16px;
    font-family: 'poppinsbold';
    border: 1px solid #3498db;
}



.facebookLink:hover {
    color: #3498db;
    font-size: 16px;
    font-family: 'poppinsbold';
    text-decoration: none;
    border: 1px solid #3498db;
}

.whatsAppLink {
    color: #3FBE4F;
    font-size: 16px;
    font-family: 'poppinsbold';
    border: 1px solid #3FBE4F;
}

.whatsAppLink:hover {
    color: #3FBE4F;
    font-size: 16px;
    font-family: 'poppinsbold';
    text-decoration: none;
    border: 1px solid #3FBE4F;
}

#labelBold label {
    font-family: 'poppinsbold';
}

.iDownIcon {
    font-size: 10px;
    margin-right: 10px;
}

.requiredColor {
    color: red;
}

.typeBox {
    padding: 10px 15px;
    background: #52273e;
    color: #fff;
    text-transform: capitalize;

}

.overflowHidden {
    overflow: hidden;
}



/*--------------------------------------------------------------
# Error 404
--------------------------------------------------------------*/
.error-404 {
    padding: 30px;
}

.error-404 h1 {
    font-size: 180px;
    font-weight: 700;
    color: #D42A9E;
    margin-bottom: 0;
    line-height: 150px;
}

.error-404 h2 {
    font-size: 24px;
    font-weight: 700;
    color: #86025c;
    margin-bottom: 30px;
}

.error-404 .btn {
    background: #884e75;
    color: #fff;
    padding: 8px 30px;
}

.error-404 .btn:hover {
    background: #5f3351;
}

@media (min-width: 992px) {
    .error-404 img {
        max-width: 50%;
    }
}

.bannertitleNew {
    font-size: 34px;
    font-family: 'poppinsbold';
    color: #fff;
    padding: 110px 0;
}

.bannertitleNew1 {
    font-size: 34px;
    font-family: 'poppinsbold';
    color: #fff;
    padding: 84px 0;
}

.donateImg {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/Donate_now_1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.financialaidbanner {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/finacial_aid_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.helpdeskbanner {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/help_desk_banner-3.jpg");
    background-repeat: no-repeat;
    height: 270px;
    width: 100%;
    background-size: cover;
}

.discountedinvestigations {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/discounted_investigations_banner.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.hairdonation {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/hair_donation_banner-3.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.homepatienthealthrecords {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/patient_health_records_banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.awarenessprogram {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/awareness_program_banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.blog {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/blog.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.aboutus {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/aboutus_banner.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.contactus {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/contactus-banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.awarenessprogrambanner {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/awareness_program_banner.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.accommodation {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/accommodation_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.ambulance {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/ambulance_banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.distributorsanticancer {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/distributors_anti_cancer_drugs_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.bloodbank {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/bloodbank_banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.conunselling {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/conunselling_banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.financialaidproviders {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/financial_aid_providers_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.homecareequipments {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/home_care_equipments_suppliers_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.hospicepalliativecare {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/hospice_care_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.cancerhospitals {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/cancer_hospitals_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.distributorssuppliers {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/distributors_suppliers_nutritional_suppliments_banner-1.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.privatenursing {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/private_nursing_bureaus_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.prosthesissuppliers {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/prosthesis_suppliers_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.wigmakerssuppliers {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/wig_makers_suppliers_banner-2.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.foodbackBanner {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/Feedback/feedback-banner.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

.freeWig {
    background-image: url("https://cwc-react.s3.ap-south-1.amazonaws.com/img/discounted_investigations_banner.jpg");
    background-repeat: no-repeat;
    height: 270px;
    background-size: cover;
}

@media only screen and (min-width: 1024px) {

    /* Your desktop styles go here */
    .Toastify__toast-container--top-center {
        top: var(--toastify-toast-top);
        left: 50%;
        transform: translateX(-50%);
        width: 65% !important;
    }
}

.print-page {
    width: 90vw;
    /* A4 width */
    height: 90vh;
    /* A4 height */
    margin: 1rem;
    padding: 1rem;
    border: 1px solid black;
    box-sizing: border-box;
    /* Include border and padding in the total width and height */
    page-break-after: always;
    /* Ensure each div represents a new page when printing */
}

.desktopShow {
    display: none;
}

.accordion .card-header:after {
    font-family: 'FontAwesome';
    content: "\\f078";
    float: right;
    color: #d42a9e;
}

.accordion .card-header.collapsed:after {
    /* symbol for "collapsed" panels */
    content: "\\f054";
    color: #d42a9e;
}

.scrollToTopBtn {
    background-color: #D42A9E;
    border-radius: 100%;
    color: white;
    cursor: pointer;
    font-size: 18px;
    line-height: 38px;
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 100;
    opacity: 0;
    transform: translateY(100px);
    transition: all 0.5s ease;
    border: 0;
    /* -webkit-box-shadow: 0px 0px 26px 0px rgba(255, 140, 0, 1) !important;
    -moz-box-shadow: 0px 0px 26px 0px rgba(255, 140, 0, 1) !important;
    box-shadow: 0px 0px 26px 0px rgba(255, 140, 0, 1) !important; */
}


.showBtn {
    opacity: 1;
    transform: translateY(0);
}

.search .searchbtn {
    padding: 5px 10px !important;
    border-radius: 0 4px 4px 0 !important;
}

.search .searchbtn:hover {
    padding: 5px 10px !important;
    color: #fff !important;
    border-radius: 0 4px 4px 0 !important;
}

.tableProFac table {
    display: block;
    width: 100%;
    overflow-x: auto;
    height: auto !important;
    font-family: 'poppinsregular';

}

.videop {
    padding: 0 !important;
}

.mobileShowNone1 {
    display: none;
}

.donerSmallText{
    width: 973px;
    margin-left: auto;
    margin-right: auto;
}

.doners {
   display: flex;
   justify-content: center;
   align-items: center;
}

.doners .col-md-2{
    flex: 0 0 12.666667%;
        max-width: 12.666667%;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,yGAAyG;AACzG;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,cAAc;AAClB;;;AAGA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;;AAGA,uGAAuG;;AAEvG,yGAAyG;;AAEzG;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA,uGAAuG;;AAEvG,yGAAyG;;AAEzG;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA,uGAAuG;AACvG,yGAAyG;;AAEzG;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA,uGAAuG;;AAEvG,uGAAuG;;AAEvG;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,qGAAqG;;;AAGrG,uGAAuG;AACvG;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;;AAGA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;;AAElB;;;;;;;;;;;;;;AAcA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,qDAAqD;;AAEzD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;;AAEvB;;;AAGA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;;;;AAKA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;;AAElB;;;AAGA;IACI,eAAe;IACf,qBAAqB;AACzB;;;;;AAKA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;;AAElB;;;;;;;;;;;;;;;;;AAiBA;IAGI,eAAe;AACnB;;AAEA;IAGI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA,qGAAqG;;;AAGrG;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI;;sDAEkD;IAClD,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;;AAEzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,uBAAuB;;AAE3B;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,cAAc;IACd,iCAAiC;AACrC;;;;;;AAMA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,wCAAwC;IACxC,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,sCAAsC;IACtC,qBAAqB;IACrB,YAAY;AAChB;;;;AAIA;IACI,gBAAgB;IAChB,kDAAkD;IAClD,0DAA0D;IAC1D,uDAAuD;IACvD,SAAS;IACT,eAAe;AACnB;;;AAGA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,qBAAqB;;AAEzB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,4BAA4B;IAC5B,uBAAuB;AAC3B;;;AAGA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,+BAA+B;IAC/B,qCAAqC;IACrC,wCAAwC;IACxC,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;;AAEf;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;;AAEf;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAGlB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;;AAEnB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,WAAW;AACf;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;AACzB;;;AAGA;IACI,UAAU;IACV,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;;;AAGvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;IAC1B,wCAAwC;IACxC,gBAAgB;IAChB,6BAA6B;;AAEjC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;AACnB;;;;AAIA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqCG;;AAEH;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;;AAEhC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;;AAE1B;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;;;AAIA;IACI,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,kBAAkB;;AAEtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,kBAAkB;;AAEtB;;AAEA;IAGI,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,UAAU;;AAEd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,eAAe;IACf,4BAA4B;;AAEhC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,wBAAwB;;AAE5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,wBAAwB;;AAE5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;;AAGA;IACI,0FAA0F;IAC1F,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,+FAA+F;IAC/F,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;;;AAIA,6GAA6G;AAC7G;IACI,aAAa;IACb,UAAU;AACd;;;;AAIA;IACI,eAAe;AACnB;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;;;AAIA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;;AAElB;;AAEA,2GAA2G;;AAE3G;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;;AAEf;;;;AAIA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;;IAEX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;;;;;;;;;;;;;;;AAgBA;;;;IAII,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;;AAE7B;;AAEA;;;;;;;;IAQI,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,sCAAsC;;AAE1C;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;IAGI,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA,6FAA6F;AAC7F;IACI,eAAe;IACf,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;;AAEtB;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,gBAAgB;QAChB;IACJ;;IAEA,QAAQ;IACR;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,UAAU;QACV,gBAAgB;QAChB;IACJ;;IAEA,QAAQ;;;AAGZ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;;;;;;;;;;AAWA,6GAA6G;AAC7G;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,6FAA6F;IAC7F,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;;;AAGhC;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;;;AAIA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,uCAAuC;IACvC,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,uCAAuC;IACvC,+EAA+E;;AAEnF;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,uCAAuC;IACvC,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;;;;AAI1B;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,uCAAuC;IACvC,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;;IAEhB,+EAA+E;;AAEnF;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;;AAElC;;;AAGA;;;;GAIG;;AAEH;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,0BAA0B;;IAE1B,2CAA2C;IAC3C;;oEAEgE;AACpE;;;AAGA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;;;AAGnB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,eAAe;;AAEnB;;AAEA;;IAEI,eAAe;;AAEnB;;AAEA,6BAA6B;;AAE7B;IACI,UAAU;AACd;;AAEA,2GAA2G;;AAE3G;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,2GAA2G;;AAE3G;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,0BAA0B;IAC1B,cAAc;;AAElB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,0BAA0B;;;AAG9B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;;;AAG1B;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA,4CAA4C;;AAE5C;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;;AAEd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,yBAAyB;AAC7B;;;;AAIA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;;AAE9B;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;;+DAE+D;AAC/D;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,2FAA2F;IAC3F,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yGAAyG;IACzG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sGAAsG;IACtG,4BAA4B;IAC5B,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,+GAA+G;IAC/G,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qGAAqG;IACrG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mHAAmH;IACnH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yGAAyG;IACzG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mFAAmF;IACnF,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mGAAmG;IACnG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iGAAiG;IACjG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uGAAuG;IACvG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qHAAqH;IACrH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iHAAiH;IACjH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sIAAsI;IACtI,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iHAAiH;IACjH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oHAAoH;IACpH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+HAA+H;IAC/H,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sIAAsI;IACtI,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oHAAoH;IACpH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,wHAAwH;IACxH,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sJAAsJ;IACtJ,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+HAA+H;IAC/H,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4HAA4H;IAC5H,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4HAA4H;IAC5H,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uGAAuG;IACvG,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+GAA+G;IAC/G,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,gCAAgC;IAChC;QACI,8BAA8B;QAC9B,SAAS;QACT,2BAA2B;QAC3B,qBAAqB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,6DAA6D;IAC7D,wBAAwB;IACxB,wDAAwD;AAC5D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,4BAA4B;IAC5B,yBAAyB;IACzB,SAAS;IACT;;mEAE+D;AACnE;;;AAGA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,6BAA6B;;AAEjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;IACI,oBAAoB;QAChB,qBAAqB;AAC7B","sourcesContent":["body {\n    font-family: 'poppinsregular' !important;\n    font-size: 14px !important;\n    color: #333 !important;\n}\n\n.bannertitle {\n    font-size: 34px;\n    font-family: 'poppinsbold';\n    color: #fff;\n    position: absolute;\n    width: 100%;\n    top: 195px;\n}\n\nselect {\n    cursor: pointer;\n}\n\n.bannerBgColor {\n    background-color: #000;\n}\n\n.imgOpacity {\n    opacity: .4;\n}\n\n.imgOpacityInner {\n    opacity: .5;\n}\n\n/* ..........................................Fontsize-14 Start......................................... */\n.BoldColor30 {\n    font-size: 30px;\n    font-family: 'poppinsbold';\n    color: #A05B8A;\n}\n\n.BoldColor28 {\n    font-size: 28px;\n    font-family: 'poppinsbold';\n    color: #A05B8A;\n}\n\n.BoldColor18 {\n    font-size: 18px;\n    font-family: 'poppinsbold';\n    color: #A05B8A;\n}\n\n.BoldColor14 {\n    font-size: 14px;\n    font-family: 'poppinsbold';\n    color: #A05B8A;\n}\n\n.RegularColor14 {\n    font-size: 14px;\n    font-family: 'poppinsregular';\n    color: #A05B8A;\n}\n\n\n.Bold14 {\n    font-size: 14px;\n    font-family: 'poppinsbold';\n}\n\n.semibold14 {\n    font-size: 14px;\n    font-family: 'poppinssemibold';\n}\n\n.medium14 {\n    font-size: 14px;\n    font-family: 'poppinsmedium';\n}\n\n.Regular14 {\n    font-size: 14px;\n    font-family: 'poppinsregular';\n}\n\n\n/* ..........................................Fontsize-14 End......................................... */\n\n/* ..........................................Fontsize-16 Start......................................... */\n\n.Bold16 {\n    font-size: 16px;\n    font-family: 'poppinsbold';\n}\n\n.semibold16 {\n    font-size: 16px;\n    font-family: 'poppinssemibold';\n}\n\n.medium16 {\n    font-size: 16px;\n    font-family: 'poppinsmedium';\n}\n\n.Regular16 {\n    font-size: 16px;\n    font-family: 'poppinsregular';\n}\n\n/* ..........................................Fontsize-16 End......................................... */\n\n/* ..........................................Fontsize-18 Start......................................... */\n\n.Bold18 {\n    font-size: 18px;\n    font-family: 'poppinsbold';\n}\n\n.semibold18 {\n    font-size: 18px;\n    font-family: 'poppinssemibold';\n}\n\n.medium18 {\n    font-size: 18px;\n    font-family: 'poppinsmedium';\n}\n\n.Regular18 {\n    font-size: 18px;\n    font-family: 'poppinsregular';\n}\n\n/* ..........................................Fontsize-18 End......................................... */\n/* ..........................................Fontsize-30 Start......................................... */\n\n.Bold28 {\n    font-size: 28px;\n    font-family: 'poppinsbold';\n}\n\n/* ..........................................Fontsize-30 End......................................... */\n\n/* ..........................................Space CSS Start......................................... */\n\n.mr0 {\n    margin-right: 0;\n}\n\n.mr5 {\n    margin-right: 5px;\n}\n\n.mr10 {\n    margin-right: 10px;\n}\n\n.mr15 {\n    margin-right: 15px;\n}\n\n.mr20 {\n    margin-right: 20px !important;\n}\n\n.mr60 {\n    margin-right: 60px;\n}\n\n\n.ml0 {\n    margin-left: 0;\n}\n\n.ml5 {\n    margin-left: 5px;\n}\n\n.ml10 {\n    margin-left: 10px;\n}\n\n.ml15 {\n    margin-left: 15px;\n}\n\n.ml20 {\n    margin-left: 20px;\n}\n\n.ml23 {\n    margin-left: 23px;\n}\n\n.mt0 {\n    margin-top: 0;\n}\n\n.mt10 {\n    margin-top: 10px;\n}\n\n.mt15 {\n    margin-top: 15px;\n}\n\n.mt20 {\n    margin-top: 20px;\n}\n\n.mt30 {\n    margin-top: 30px;\n}\n\n.mt36 {\n    margin-top: 36px;\n}\n\n.mb0 {\n    margin-bottom: 0;\n}\n\n.mb10 {\n    margin-bottom: 10px;\n}\n\n.mb15 {\n    margin-bottom: 15px;\n}\n\n.mb20 {\n    margin-bottom: 20px;\n}\n\n.mb30 {\n    margin-bottom: 30px;\n}\n\n.mb40 {\n    margin-bottom: 40px;\n}\n\n\n\n.p0 {\n    padding: 0 !important;\n}\n\n.p10 {\n    padding: 10px;\n}\n\n.p15 {\n    padding: 15px;\n}\n\n.p20 {\n    padding: 20px;\n}\n\n.p30 {\n    padding: 30px;\n}\n\n.p40 {\n    padding: 40px;\n}\n\n.pt0 {\n    padding-top: 0;\n}\n\n.pb0 {\n    padding-bottom: 0 !important;\n}\n\n\n\n.p150 {\n    padding: 15px 0;\n}\n\n.br {\n    border-right: 0 !important;\n}\n\n/* ..........................................Space CSS End......................................... */\n\n\n/* ..........................................ul li CSS Start......................................... */\n.urlLinkRgular {\n    color: #D42A9E;\n}\n\n.urlLinkRgular:hover {\n    color: #ff00ae;\n    text-decoration: none;\n}\n\n\n.noFlexlistContent {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n.noFlexlistContent li {\n    margin-bottom: 10px;\n    margin-left: 20px;\n}\n\n.noFlexlistContent li::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n.listContent {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n.listContent li {\n    margin-bottom: 10px;\n    font-family: 'poppinsmedium';\n    /* display: flex; */\n}\n\n.listContent li::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n    /* background-image: url(\"../img/right-arrow.png\"); */\n\n}\n\n.listContent .iIcon {\n    color: #A05B8A;\n    font-size: 14px;\n}\n\n.listContentRegular {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n.listContentRegular li {\n    margin-bottom: 10px;\n    font-family: 'poppinsregular';\n    /* display: flex; */\n\n}\n\n\n.listContentRegular li::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n\n}\n\n.listContentRegular .iIcon {\n    color: #A05B8A;\n    font-size: 14px;\n}\n\n.commoniIcon {\n    color: #A05B8A;\n    font-size: 14px;\n}\n\n.listContentUrl {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n.listContentUrl li {\n    margin-bottom: 10px;\n    color: #A05B8A;\n}\n\n.listContentUrl li a {\n    color: #A05B8A;\n}\n\n.listContentUrl li a::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n\n}\n\n.listContentUrl li a:hover {\n    color: #A05B8A;\n    text-decoration: none;\n    color: #D42A9E;\n}\n\n.listContentUrl .iIcon {\n    font-size: 14px;\n}\n\n.alistContentUrl a {\n    margin-bottom: 10px;\n    color: #A05B8A;\n    font-size: 14px;\n    font-family: 'poppinsmedium';\n}\n\n.alistContentUrl div {\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.listContentP {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n\n\n\n.listContentP li p {\n    margin-bottom: 10px;\n    font-family: 'poppinsmedium';\n    /* display: flex; */\n}\n\n.listContentP li p::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n\n}\n\n\n.listContentPregular {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n\n\n\n.listContentPregular li p {\n    margin-bottom: 10px;\n    font-family: 'poppinsregular';\n    /* display: flex; */\n}\n\n.listContentPregular li p::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.ulList {\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n}\n\n.ulList2 {\n    -webkit-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n}\n\n.list-style {\n    list-style-type: disc;\n    padding-left: 20px !important;\n}\n\n.list-style strong {\n    display: block;\n}\n\n/* ..........................................ul li CSS End......................................... */\n\n\n.tataContentBox {\n    background-color: #ffffff;\n    border: 1px solid #F3DDDE;\n    border-radius: 4px;\n    padding: 20px;\n}\n\n.tataContentBoxGray {\n    background-color: #EEF4F6;\n    border-radius: 4px;\n    padding: 20px;\n}\n\n.displayNone {\n    display: none;\n}\n\n.header-wrapper {\n    padding: 32px 24px 0 24px;\n    display: flex;\n    position: sticky;\n    top: 0;\n    z-index: 3;\n    background-color: #eee;\n}\n\n.shadow {\n    /* -webkit-box-shadow: 0 14px 12px -6px rgb(230, 230, 230);\n    -moz-box-shadow: 0 14px 12px -6px rgb(230, 230, 230);\n    box-shadow: 0 14px 12px -6px rgb(230, 230, 230); */\n    border-bottom: 1px solid #ddd !important;\n}\n\n.wrapper {\n    height: 200vh;\n}\n\n\n\n.cardImg {\n    width: 100%;\n}\n\n.displayNone {\n    display: none;\n}\n\n\n.socialMediaSection {\n    background-color: #3D1D33;\n    padding: 5px 0;\n    width: 100%;\n    display: block;\n}\n\n.socialHeader {\n    display: flex;\n    align-items: center;\n}\n\n.socialIcon {\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n}\n\n.search {\n    display: flex;\n    width: 70%;\n\n}\n\n.search a {\n    margin-right: 20px;\n    color: #9E8E99;\n    text-decoration: none;\n\n}\n\n.socialIcon a {\n    padding: 0 10px;\n    color: #9E8E99;\n}\n\n.socialTitle {\n    color: #9E8E99;\n    margin-right: 5px;\n}\n\n\n.flex {\n    display: flex;\n    align-items: center;\n}\n\n.flexJustify {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.flexJustify1 {\n    display: flex;\n    justify-content: center;\n\n}\n\n\ninput {\n    font-size: 14px !important;\n}\n\n.bg-light {\n    padding: 0;\n    display: block;\n    background-color: #fff !important;\n}\n\n\n\n\n\n.nav-link {\n    display: block;\n    padding: 1.3rem 1rem;\n}\n\n.search .form-control {\n    line-height: 1.5;\n}\n\n.main {\n    width: 50%;\n    margin: 50px auto;\n}\n\n\n.has-search .form-control {\n    padding-left: 2.375rem;\n}\n\n.has-search .form-control-feedback {\n    position: absolute;\n    z-index: 2;\n    display: block;\n    width: 2.375rem;\n    height: 2.375rem;\n    line-height: 2rem;\n    text-align: center;\n    pointer-events: none;\n    color: #aaa;\n}\n\n.search .form-group {\n    margin-bottom: 0;\n}\n\n.navbar-nav .nav-link {\n    color: #000 !important;\n    font-family: 'poppinsbold';\n    /* border-bottom: 3px solid #0078d300; */\n    /* padding-right: 1.5rem !important; */\n    text-decoration: none;\n}\n\n.navbar-nav li a {\n    color: #000 !important;\n    font-family: 'poppinsbold';\n    text-decoration: none;\n    height: 63px;\n}\n\n\n.navbar-nav li a:hover {\n    color: #D42A9E !important;\n    font-family: 'poppinsbold';\n    /* border-bottom: 3px solid #D42A9E; */\n    text-decoration: none;\n    height: 63px;\n}\n\n\n\n.dropdown-menu {\n    margin: 0rem 0 0;\n    box-shadow: 0px 2px 9px 0px rgba(89, 89, 89, 0.48);\n    -webkit-box-shadow: 0px 2px 9px 0px rgba(89, 89, 89, 0.48);\n    -moz-box-shadow: 0px 2px 9px 0px rgba(89, 89, 89, 0.48);\n    border: 0;\n    font-size: 14px;\n}\n\n\n.dropdown-menu a {\n    color: #333 !important;\n    text-transform: none;\n    padding: 21px 15px;\n    font-family: 'poppinsregular';\n}\n\n.boxes {\n    transition: all 1s;\n}\n\n.dropdown-menu li {\n    color: #A05B8A !important;\n    font-family: 'poppinsregular' !important;\n    padding: 0 !important;\n\n}\n\n.dropdown-menu li a {\n    color: #A05B8A !important;\n    font-family: 'poppinsregular' !important;\n    padding: 8px 14px !important;\n    height: auto !important;\n}\n\n\n.dropdown-menu li a:hover {\n    color: #D42A9E !important;\n    text-transform: none !important;\n    transition: all 0.5s !important;\n    transform: translateX(5px) !important;\n    background-color: transparent !important;\n    border-bottom: 0;\n    font-family: 'poppinsregular';\n}\n\n.dropdownItem {\n    display: block;\n}\n\n.dropdown .dropdown-toggle::after {\n    vertical-align: 0.1em;\n}\n\n.navbar-brand {\n    margin-right: 6rem;\n}\n\n\n.topspace {\n    margin-top: 108px;\n}\n\n.topHeight {\n    height: 30px;\n}\n\n.bannerContent {\n    position: absolute;\n    z-index: 999;\n    text-align: center;\n    top: 150px;\n    width: 49%;\n    left: 360px;\n\n}\n\n.bannerContent h2 {\n    font-family: 'poppinsbold';\n    color: #fff;\n    line-height: 56px;\n    font-size: 39px;\n}\n\n.bannerContent p {\n    color: #fff;\n    width: 477px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n\n\n.bannerContent2 {\n    position: absolute;\n    z-index: 999;\n    text-align: center;\n    top: 180px;\n    width: 49%;\n    left: 360px;\n\n}\n\n.bannerContent2 h2 {\n    font-family: 'poppinsbold';\n    color: #fff;\n    line-height: 56px;\n    font-size: 39px;\n}\n\n.bannerContent2 p {\n    color: #fff;\n    width: 477px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n\n.colorTitle {\n    color: #D42A9E;\n}\n\n.carousel-indicators li {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 1 auto;\n    flex: 0 1 auto;\n    width: 10px;\n    height: 10px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    background-color: rgba(255, 255, 255, .5);\n    border-radius: 100%;\n    cursor: pointer;\n}\n\n.carousel-indicators .active {\n    background-color: #D42A9E;\n}\n\n.btn-primary {\n    background-color: #D42A9E;\n    text-transform: uppercase;\n    font-size: 14px;\n    border: 2px solid #f7c5e7;\n}\n\n.btn-primary:hover {\n    background-color: #D42A9E;\n    border: 2px solid #f7c5e7;\n}\n\n.btn-primary:focus {\n    box-shadow: none;\n    background-color: #D42A9E;\n}\n\n.btn:hover {\n    transform: translateY(-2px);\n}\n\n.btn {\n    transition: transform 250ms;\n    font-size: 14px;\n\n}\n\n.Allbtn {\n    font-family: 'poppinsregular';\n    color: #fff !important;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active {\n    border: none;\n    background-color: #D42A9E;\n}\n\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-primary.dropdown-toggle:focus {\n    box-shadow: none;\n    background-color: #D42A9E;\n}\n\n.banner-btn {\n    border-radius: 100%;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #D42A9E;\n}\n\n.title {\n    font-family: 'poppinsbold';\n    font-size: 28px;\n    margin-bottom: 0px\n}\n\n.titleWhite {\n    font-family: 'poppinsbold';\n    font-size: 28px;\n    margin-bottom: 0px;\n    color: #fff;\n\n}\n\n.whiteContent {\n    color: #fff;\n}\n\n\n\n.tagLine {\n    color: #666;\n}\n\n.tagLineWhite {\n    color: #fff;\n}\n\n.contentSection {\n    padding: 50px 0;\n}\n\n\n.divider {\n    border: 2px solid #D42A9E;\n    margin: 10px 0;\n    width: 90px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.dividerWhite {\n    border: 2px solid #ffffff;\n    margin: 10px 0;\n    width: 90px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.footerBg {\n    background-color: #3D1D33;\n    padding: 30px 0;\n}\n\n\n.boxes1 {\n    transition: all 1s;\n}\n\n.footerLink {\n    padding: 0;\n    width: 300px;\n    list-style-type: none;\n}\n\n\n.footerLink li a {\n    padding: 0;\n    color: #9E8E99 !important;\n    font-size: 14px !important;\n    margin-bottom: 15px;\n\n\n}\n\n.footerLink li a:hover {\n    color: #D42A9E !important;\n    text-transform: none;\n    transition: all 0.5s;\n    transform: translateX(5px);\n    background-color: transparent !important;\n    border-bottom: 0;\n    font-family: 'poppinsregular';\n\n}\n\n.footerMenuTitle {\n    font-family: 'poppinsbold';\n    font-size: 18px;\n    color: #A05B8A;\n    margin-bottom: 10px;\n\n}\n\n.socialIcon .btn {\n    padding: 0;\n    font-size: 14px !important;\n}\n\n.socialIcon .btn:hover {\n    color: #D42A9E !important;\n}\n\n.search .btn {\n    padding: 0;\n    font-size: 14px !important;\n}\n\n.search .btn:hover {\n    color: #D42A9E !important;\n}\n\n.copyRight {\n    color: #A799A3;\n    padding: 15px 0;\n    text-align: center;\n    background-color: #503447;\n}\n\n.contentBox {\n\n    padding: 40px 0;\n}\n\n\n\n.listContentRegular {\n    padding-left: 0;\n    list-style-type: none;\n}\n\n/* \n#listyling ul {\n    list-style-type: none;\n    content: '\\f061';\n    list-style-position: inside;\n    padding-left: 1.5em;\n    padding-left: 0;\n\n\n}\n\n#listyling ul li a {\n    margin-bottom: 15px;\n    color: #A05B8A;\n    text-decoration: none;\n}\n\n#listyling ul li a:hover {\n    margin-bottom: 15px;\n    color: #A05B8A;\n    text-decoration: none;\n    color: #D42A9E;\n}\n\n#listyling ul li::before {\n    font-family: \"Font Awesome 5 Free\";\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n    font-weight: 900;\n    content: '\\f061';\n    margin-right: 10px;\n    color: #A05B8A;\n\n} */\n\n.threeLineText {\n    overflow: hidden;\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n\n}\n\n.threeLineTitle {\n    overflow: hidden;\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    color: #000;\n}\n\n.threeLineTitle:hover {\n    color: #D42A9E;\n    text-decoration: none;\n}\n\n.threeLineTitleNew {\n    overflow: hidden;\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    color: #000;\n}\n\n.threeLineTitleNew:hover {\n    color: #000;\n    text-decoration: none;\n    cursor: auto;\n}\n\n/* .aLink {\n    color: #D42A9E;\n    text-decoration: none;\n\n}\n\n.aLink:hover {\n    color: #D42A9E;\n    text-decoration: none;\n\n} */\n\n.darkPinkBg {\n    background-color: #3D1D33;\n}\n\n.grayBg {\n    background-color: #EEF4F6;\n}\n\n.roundedBox {\n    border-radius: 10px;\n    background-color: #fff;\n\n}\n\n.titleBg {\n    border-radius: 10px 10px 0 0;\n    padding: 15px;\n    background-color: #A05B8A;\n    font-size: 18px;\n    color: #fff;\n    font-family: 'poppinssemibold';\n    display: flex;\n    align-items: center;\n}\n\n.roundedBoxContent {\n    padding: 15px;\n}\n\n.iIconRight {\n    color: #A05B8A;\n    font-size: 14px;\n    margin-top: 3px;\n    position: absolute;\n    left: 35px;\n}\n\n\n\n.dateFormat {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #666666;\n    margin-bottom: 5px;\n\n}\n\n.dateFormatGray {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #999;\n    margin-bottom: 5px;\n\n}\n\n.addFormatGray {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #999;\n    margin-bottom: 5px;\n\n}\n\n.feedbackCards {\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    column-count: 3;\n    list-style-type: none;\n    padding: 0;\n\n}\n\n.liBlock {\n    display: inline-block;\n}\n\n.tableNumber1 {\n    text-align: center;\n    background: #A05B8A;\n    padding: 20px 0 0;\n    width: 25%;\n    color: #fff;\n    font-size: 34px;\n    font-family: 'poppinsmedium';\n    border-radius: 4px 0 0 0;\n}\n\n.tableNumber2 {\n    text-align: center;\n    background: #965BA0;\n    padding: 20px 0 0;\n    width: 25%;\n    color: #fff;\n    font-size: 34px;\n    font-family: 'poppinsmedium';\n\n}\n\n.tableNumber3 {\n    text-align: center;\n    background: #5BA09C;\n    padding: 20px 0 0;\n    width: 25%;\n    color: #fff;\n    font-size: 34px;\n    font-family: 'poppinsmedium';\n}\n\n.tableNumber4 {\n    text-align: center;\n    background: #5CA05B;\n    padding: 20px 0 0;\n    width: 25%;\n    color: #fff;\n    font-size: 34px;\n    font-family: 'poppinsmedium';\n    border-radius: 0 4px 0 0;\n\n}\n\n.tableHeading1 {\n    text-align: center;\n    background: #A05B8A;\n    padding: 0 20px 20px;\n    width: 25%;\n    color: #fff;\n    border-radius: 0 0 0 4px;\n}\n\n.tableHeading2 {\n    text-align: center;\n    background: #965BA0;\n    padding: 0 20px 20px;\n    width: 25%;\n    color: #fff;\n}\n\n.tableHeading3 {\n    text-align: center;\n    background: #5BA09C;\n    padding: 0 20px 20px;\n    width: 25%;\n    color: #fff;\n}\n\n.tableHeading4 {\n    text-align: center;\n    background: #5CA05B;\n    padding: 0 20px 20px;\n    width: 25%;\n    color: #fff;\n    border-radius: 0 0 4px 0;\n\n}\n\n.pm {\n    margin-left: 25px;\n}\n\n.imgBox {\n    border-radius: 4px;\n    border: 1px solid #999999;\n}\n\n.linkBox {\n    background-color: #EEF4F6;\n    padding: 20px;\n}\n\n\n.twitterIcon {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/twitterIcon.png\");\n    width: 13px;\n    height: 12px;\n    background-repeat: no-repeat;\n}\n\n.twitterIcon:hover {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/twitterIconColor.png\");\n    width: 13px;\n    height: 12px;\n    transform: translateY(-2px);\n}\n\n.cBtn {\n    transition: transform 250ms;\n}\n\n\n\n/* ............................................tabs start.................................................. */\n.required:after {\n    content: \" *\";\n    color: red;\n}\n\n\n\n.form-control {\n    font-size: 14px;\n}\n\n\n\n.form-group ::placeholder {\n    color: #999;\n}\n\n.contactInfoBox {\n    background-color: #EEF4F6;\n    padding: 20px;\n    border-radius: 4px;\n}\n\n\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n    border-top: #FFFFFF;\n    border-right: #FFFFFF;\n    border-left: #FFFFFF;\n    border-bottom: 3px solid #D42A9E;\n    color: #D42A9E !important;\n}\n\n.nav-tabs {\n    border-bottom: 1px solid #fff;\n}\n\n\n.nav-tabs .nav-link {\n    border: 0px solid transparent;\n    padding: 10px 0;\n    margin-right: 30px;\n}\n\n#myTab li a {\n    font-family: 'poppinsmedium';\n    color: #999999;\n\n}\n\n/* ............................................tabs end.................................................. */\n\n.locationSelector {\n    /* background-color: #f3f3f3; */\n    background-color: #52273e;\n    padding: 20px 50px;\n    border-radius: 4px;\n\n}\n\n.locationSelector label {\n    color: #fff;\n\n}\n\n\n\n.addressBox {\n    border: 1px solid #D9D9D9;\n    border-radius: 4px;\n    background-color: #FEFEFE;\n    height: 100%;\n}\n\n.innerAddressBox {\n    padding: 20px;\n}\n\n.addressTitle {\n    background-color: #b55b8a;\n    padding: 15px;\n    color: #fff;\n}\n\n\n.textwithImg {\n    width: auto;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    float: left;\n    margin-right: 30px;\n}\n\n.textwithImg1 {\n    width: auto;\n\n    margin-bottom: 20px;\n    float: right;\n    margin-left: 30px;\n}\n\n.videoYoutube {\n    height: 304px;\n    width: 100%;\n}\n\n.homeVideoYoutube {\n    height: 416px;\n    width: 50%;\n}\n\n.form-inline a {\n    padding: 0.375rem 0.75rem !important;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.mainmenu a,\n.navbar-default .navbar-nav>li>a,\n.mainmenu ul li a,\n.navbar-expand-lg .navbar-nav .nav-link {\n    color: #000;\n    font-size: 14px;\n    padding: 21px 15px;\n    display: block !important;\n\n}\n\n.mainmenu .active a,\n.mainmenu .active a:focus,\n.mainmenu .active a:hover,\n.mainmenu li a:hover,\n.mainmenu li a:focus,\n.navbar-default .navbar-nav>.show>a,\n.navbar-default .navbar-nav>.show>a:focus,\n.navbar-default .navbar-nav>.show>a:hover {\n    color: #D42A9E;\n    background: #ffffff;\n    outline: 0;\n    padding: 21px 15px;\n    /* border-bottom: 3px solid #D42A9E; */\n\n}\n\n/*==========Sub Menu=v==========*/\n.mainmenu .collapse ul>li:hover>a {\n    background: #fff;\n    padding: 21px 15px;\n}\n\n.mainmenu .collapse ul ul>li:hover>a,\n.navbar-default .navbar-nav .show .dropdown-menu>li>a:focus,\n.navbar-default .navbar-nav .show .dropdown-menu>li>a:hover {\n    background: #fff;\n    border-bottom: 0;\n    /* padding: 21px 15px; */\n    padding: 15px 15px;\n}\n\n.mainmenu .collapse ul ul ul>li:hover>a {\n    background: #fff;\n    /* padding: 21px 15px; */\n    padding: 15px 15px;\n}\n\n.mainmenu .collapse ul ul,\n.mainmenu .collapse ul ul.dropdown-menu {\n    background: #fff;\n    /* padding: 21px 15px; */\n    padding: 15px 15px;\n}\n\n.mainmenu .collapse ul ul ul,\n.mainmenu .collapse ul ul ul.dropdown-menu {\n    background: #fff;\n}\n\n.mainmenu .collapse ul ul ul ul,\n.mainmenu .collapse ul ul ul ul.dropdown-menu {\n    background: #fff;\n}\n\n/******************************Drop-down menu work on hover**********************************/\n.mainmenu {\n    border: 0 solid;\n    margin: 0;\n    padding: 14px 0;\n    min-height: 100%;\n    width: 100%;\n    background: #fff;\n    font-family: 'poppinsbold';\n    padding: 21px 15px;\n\n}\n\n@media only screen and (min-width: 767px) {\n    .mainmenu .collapse ul li:hover>ul {\n        display: block\n    }\n\n    .mainmenu .collapse ul ul {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        min-width: 265px;\n        display: none\n    }\n\n    /*******/\n    .mainmenu .collapse ul ul li {\n        position: relative\n    }\n\n    .mainmenu .collapse ul ul li:hover>ul {\n        display: block\n    }\n\n    .mainmenu .collapse ul ul ul {\n        position: absolute;\n        top: 0;\n        left: 100%;\n        min-width: 250px;\n        display: none\n    }\n\n    /*******/\n\n\n}\n\n@media only screen and (max-width: 767px) {\n    .navbar-nav .show .dropdown-menu .dropdown-menu>li>a {\n        padding: 16px 15px 16px 35px\n    }\n\n    .navbar-nav .show .dropdown-menu .dropdown-menu .dropdown-menu>li>a {\n        padding: 16px 15px 16px 45px\n    }\n}\n\n\n\n\n\n\n\n\n\n\n/* ............................................tabs start.................................................. */\n.stepsBg .required:after {\n    content: \" *\";\n    color: red;\n}\n\n.stepsBg .form-control {\n    font-size: 14px;\n}\n\n\n\n.stepsBg .form-group ::placeholder {\n    color: #999;\n}\n\n.stepsBg .contactInfoBox {\n    background-color: #EEF4F6;\n    padding: 20px;\n    border-radius: 4px;\n}\n\n.stepsbgImg {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/steps-bg.jpg\");\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n\n\n}\n\n.stepContentBox {\n    border-radius: 0 0 4px 4px;\n    padding: 20px;\n    background-color: #fff;\n    height: 458px;\n    overflow-y: scroll;\n}\n\n\n\n.stepsBg .nav-tabs .nav-item.show .nav-link,\n.stepsBg .nav-tabs .nav-link {\n    border-top: #FFFFFF;\n    border-right: #FFFFFF;\n    border-left: #FFFFFF;\n    padding: 10px 10px 20px 10px !important;\n    /* border-radius: 10px; */\n    color: #fff !important;\n    /* background-color: #999; */\n    /* border: 2px solid #999 !important; */\n    clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 69% 75%, 50% 99%, 30% 75%, 0% 75%);\n\n}\n\n.stepsBg .nav-tabs .nav-item.show .nav-link,\n.stepsBg .nav-tabs .nav-link:hover {\n    border-top: #FFFFFF;\n    border-right: #FFFFFF;\n    border-left: #FFFFFF;\n    padding: 10px 10px 20px 10px !important;\n    /* border-radius: 10px; */\n    color: #fff !important;\n    background-color: #999;\n\n\n\n}\n\n.stepsBg .nav-tabs .nav-item.show .nav-link,\n.stepsBg .nav-tabs .nav-link.active {\n    border-top: #FFFFFF;\n    border-right: #FFFFFF;\n    border-left: #FFFFFF;\n    padding: 10px 10px 20px 10px !important;\n    /* border-radius: 10px; */\n    color: #fff !important;\n    background-color: #d42a9e;\n    border-bottom: 0;\n\n    clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 69% 75%, 50% 99%, 30% 75%, 0% 75%);\n\n}\n\n.stepsBg .nav-tabs {\n    border-bottom: 1px solid transparent !important;\n    padding: 0 0 10px 0 !important;\n\n}\n\n\n/* .stepsBg .nav-tabs .nav-link {\n    border: 0px solid transparent;\n    padding: 10px 0;\n    margin-right: 50px;\n} */\n\n.stepGrayBg {\n    /* background-color: #f3f3f3; */\n    /* padding: 20px 10px 0 10px; */\n    border-radius: 4px 4px 0 0;\n\n    border-bottom: 2px solid #d42a9e !important;\n    /* -webkit-box-shadow: inset 0px -18px 31px -12px rgba(179, 179, 179, 1);\n    -moz-box-shadow: inset 0px -18px 31px -12px rgba(179, 179, 179, 1);\n    box-shadow: inset 0px -18px 31px -12px rgba(179, 179, 179, 1); */\n}\n\n\n.stepsBg #myTab li a {\n    font-family: 'poppinsbold';\n    color: #B5B5B5;\n    font-size: 18px;\n\n\n}\n\n#accordion a {\n    font-family: 'poppinsbold';\n    color: #d42a9e;\n    font-size: 18px;\n    cursor: pointer;\n\n}\n\n.cardHeader {\n\n    cursor: pointer;\n\n}\n\n/* Spinner.css (CSS Styles) */\n\n.tableWidth {\n    width: 60%;\n}\n\n/* ............................................tabs end.................................................. */\n\n.socialIcons {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n\n.socialIcons li {\n    float: left;\n    padding: 20px;\n    border: 1px solid #ccc;\n    height: 30px;\n    width: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.socialIcons li a {\n    display: block;\n    color: #999;\n    text-align: center;\n    text-decoration: none;\n    font-size: 15px;\n}\n\n.socialIcons li a:hover {\n    color: #D42A9E;\n}\n\n.titleWidth {\n    width: 67%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n}\n\n.imgFixbox {\n    background: #fff;\n    border: 1px solid #ddd;\n    padding: 10px;\n    height: 100%;\n    display: inline-table;\n}\n\n.imgFixbox1 {\n    background: #fff;\n    border: 1px solid #ddd;\n    padding: 10px;\n    height: 100%;\n    display: inline-table;\n    width: 100%;\n}\n\n.imgFixbox2 {\n    background: #fff;\n    border: 1px solid #ddd;\n    padding: 10px;\n    height: 100%;\n    display: inline-table;\n    width: 100%;\n    margin: 10px;\n}\n\n.imgFixbox3 {\n    background: #fff;\n    border: 1px solid #ddd;\n    padding: 10px;\n    height: 129px;\n    display: inline-table;\n    width: 100%;\n    margin-bottom: 15px;\n}\n\n.imgFixboxBorder {\n\n    border: 1px solid #7c7c7c;\n    padding: 10px;\n    height: 129px;\n    display: inline-table;\n    width: 100%;\n    margin-bottom: 15px;\n}\n\n.spinner-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 25vh;\n    margin: auto;\n}\n\n.spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-top: 4px solid #3498db;\n    /* Change the color to your liking */\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* ............................................tabs end.................................................. */\n\n.peginationBox a {\n    padding: 8px 10px;\n    cursor: pointer;\n    border: 2px solid #ccc;\n    margin: 5px;\n    font-family: 'poppinsbold';\n    color: #d42a9e;\n\n}\n\n.peginationBox a:hover {\n    padding: 8px 10px;\n    cursor: pointer;\n    border: 2px solid #d42a9e;\n    margin: 5px;\n    color: #d42a9e;\n    font-family: 'poppinsbold';\n\n\n}\n\n.peginationActive {\n    border: 2px solid #d42a9e !important;\n    color: #d42a9e !important;\n}\n\n.imgAdjt {\n    float: right;\n    margin-right: 363px;\n    margin-left: 20px;\n}\n\n.imgAdjt0 {\n    float: right;\n    margin-right: 0px;\n    margin-left: 20px;\n}\n\n.emailUsImg {\n    background-image: url(\"../img/Hair donation/emailUsImg.jpg\");\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n\n\n}\n\n.searchWidth .main {\n    width: 50%;\n    margin: 50px auto;\n}\n\n/* Bootstrap 4 text input with search icon */\n\n.searchWidth .has-search .form-control {\n    padding-left: 2.375rem;\n}\n\n.searchWidth .has-search .form-control-feedback {\n    position: absolute;\n    z-index: 2;\n    display: block;\n    width: 2.375rem;\n    height: 2.375rem;\n    line-height: 2.375rem;\n    text-align: center;\n    pointer-events: none;\n    color: #aaa;\n}\n\n.form-card{\n    border: #ddd 1px solid;\n    padding: 1rem;\n}\n\n.buttonColor {\n    background-color: #D42A9E;\n    border-color: #D42A9E;\n}\n\n.buttonColor:hover {\n    background-color: #9c076d;\n    border-color: #D42A9E;\n}\n\n.buttonColor:focus {\n    background-color: #9c076d;\n    border-color: #D42A9E;\n}\n\n.buttonColor:active {\n    background-color: #9c076d !important;\n    border-color: #D42A9E;\n}\n\n.input-group-append .btn:hover {\n    transform: none;\n}\n\n.searchWidth {\n    width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.olListTypenone {\n    list-style-type: none;\n    padding: 0;\n\n}\n\n.whatsAppIcon {\n    color: #3FBE4F;\n}\n\n.footerLink .dropdown-item:focus {\n    background-color: transparent;\n}\n\n.wordBreak {\n    word-wrap: break-word;\n}\n\n.modalDialog {\n    max-width: 750px;\n}\n\n.modalHeader {\n    border-bottom: 0;\n}\n\n.image-gallery-left-nav .image-gallery-svg,\n.image-gallery-right-nav .image-gallery-svg {\n    height: 101px !important;\n    width: 42px !important;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.modalHeight {\n    max-height: 493px;\n    overflow: auto;\n}\n\n/* .AllbtnImg {\n    font-family: 'poppinsregular';\n    color: #fff !important;\n}\n\n.AllbtnImg:hover {\n    font-family: 'poppinsregular';\n    color: #fff !important;\n    background-image: url(\"../img/3-1.png\");\n} */\n\n.facebookLink {\n    color: #3498db;\n    font-size: 16px;\n    font-family: 'poppinsbold';\n    border: 1px solid #3498db;\n}\n\n\n\n.facebookLink:hover {\n    color: #3498db;\n    font-size: 16px;\n    font-family: 'poppinsbold';\n    text-decoration: none;\n    border: 1px solid #3498db;\n}\n\n.whatsAppLink {\n    color: #3FBE4F;\n    font-size: 16px;\n    font-family: 'poppinsbold';\n    border: 1px solid #3FBE4F;\n}\n\n.whatsAppLink:hover {\n    color: #3FBE4F;\n    font-size: 16px;\n    font-family: 'poppinsbold';\n    text-decoration: none;\n    border: 1px solid #3FBE4F;\n}\n\n#labelBold label {\n    font-family: 'poppinsbold';\n}\n\n.iDownIcon {\n    font-size: 10px;\n    margin-right: 10px;\n}\n\n.requiredColor {\n    color: red;\n}\n\n.typeBox {\n    padding: 10px 15px;\n    background: #52273e;\n    color: #fff;\n    text-transform: capitalize;\n\n}\n\n.overflowHidden {\n    overflow: hidden;\n}\n\n\n\n/*--------------------------------------------------------------\n# Error 404\n--------------------------------------------------------------*/\n.error-404 {\n    padding: 30px;\n}\n\n.error-404 h1 {\n    font-size: 180px;\n    font-weight: 700;\n    color: #D42A9E;\n    margin-bottom: 0;\n    line-height: 150px;\n}\n\n.error-404 h2 {\n    font-size: 24px;\n    font-weight: 700;\n    color: #86025c;\n    margin-bottom: 30px;\n}\n\n.error-404 .btn {\n    background: #884e75;\n    color: #fff;\n    padding: 8px 30px;\n}\n\n.error-404 .btn:hover {\n    background: #5f3351;\n}\n\n@media (min-width: 992px) {\n    .error-404 img {\n        max-width: 50%;\n    }\n}\n\n.bannertitleNew {\n    font-size: 34px;\n    font-family: 'poppinsbold';\n    color: #fff;\n    padding: 110px 0;\n}\n\n.bannertitleNew1 {\n    font-size: 34px;\n    font-family: 'poppinsbold';\n    color: #fff;\n    padding: 84px 0;\n}\n\n.donateImg {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/Donate_now_1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.financialaidbanner {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/finacial_aid_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.helpdeskbanner {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/help_desk_banner-3.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    width: 100%;\n    background-size: cover;\n}\n\n.discountedinvestigations {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/discounted_investigations_banner.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.hairdonation {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/hair_donation_banner-3.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.homepatienthealthrecords {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/patient_health_records_banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.awarenessprogram {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/awareness_program_banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.blog {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/blog.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.aboutus {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/About/aboutus_banner.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.contactus {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/contactus-banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.awarenessprogrambanner {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/awareness_program_banner.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.accommodation {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/accommodation_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.ambulance {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/ambulance_banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.distributorsanticancer {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/distributors_anti_cancer_drugs_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.bloodbank {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/bloodbank_banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.conunselling {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/conunselling_banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.financialaidproviders {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/financial_aid_providers_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.homecareequipments {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/home_care_equipments_suppliers_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.hospicepalliativecare {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/hospice_care_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.cancerhospitals {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/cancer_hospitals_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.distributorssuppliers {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/distributors_suppliers_nutritional_suppliments_banner-1.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.privatenursing {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/private_nursing_bureaus_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.prosthesissuppliers {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/prosthesis_suppliers_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.wigmakerssuppliers {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/wig_makers_suppliers_banner-2.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.foodbackBanner {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/Feedback/feedback-banner.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n.freeWig {\n    background-image: url(\"https://cwc-react.s3.ap-south-1.amazonaws.com/img/discounted_investigations_banner.jpg\");\n    background-repeat: no-repeat;\n    height: 270px;\n    background-size: cover;\n}\n\n@media only screen and (min-width: 1024px) {\n\n    /* Your desktop styles go here */\n    .Toastify__toast-container--top-center {\n        top: var(--toastify-toast-top);\n        left: 50%;\n        transform: translateX(-50%);\n        width: 65% !important;\n    }\n}\n\n.print-page {\n    width: 90vw;\n    /* A4 width */\n    height: 90vh;\n    /* A4 height */\n    margin: 1rem;\n    padding: 1rem;\n    border: 1px solid black;\n    box-sizing: border-box;\n    /* Include border and padding in the total width and height */\n    page-break-after: always;\n    /* Ensure each div represents a new page when printing */\n}\n\n.desktopShow {\n    display: none;\n}\n\n.accordion .card-header:after {\n    font-family: 'FontAwesome';\n    content: \"\\f078\";\n    float: right;\n    color: #d42a9e;\n}\n\n.accordion .card-header.collapsed:after {\n    /* symbol for \"collapsed\" panels */\n    content: \"\\f054\";\n    color: #d42a9e;\n}\n\n.scrollToTopBtn {\n    background-color: #D42A9E;\n    border-radius: 100%;\n    color: white;\n    cursor: pointer;\n    font-size: 18px;\n    line-height: 38px;\n    width: 50px;\n    height: 50px;\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 100;\n    opacity: 0;\n    transform: translateY(100px);\n    transition: all 0.5s ease;\n    border: 0;\n    /* -webkit-box-shadow: 0px 0px 26px 0px rgba(255, 140, 0, 1) !important;\n    -moz-box-shadow: 0px 0px 26px 0px rgba(255, 140, 0, 1) !important;\n    box-shadow: 0px 0px 26px 0px rgba(255, 140, 0, 1) !important; */\n}\n\n\n.showBtn {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.search .searchbtn {\n    padding: 5px 10px !important;\n    border-radius: 0 4px 4px 0 !important;\n}\n\n.search .searchbtn:hover {\n    padding: 5px 10px !important;\n    color: #fff !important;\n    border-radius: 0 4px 4px 0 !important;\n}\n\n.tableProFac table {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    height: auto !important;\n    font-family: 'poppinsregular';\n\n}\n\n.videop {\n    padding: 0 !important;\n}\n\n.mobileShowNone1 {\n    display: none;\n}\n\n.donerSmallText{\n    width: 973px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.doners {\n   display: flex;\n   justify-content: center;\n   align-items: center;\n}\n\n.doners .col-md-2{\n    flex: 0 0 12.666667%;\n        max-width: 12.666667%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
